import { render, staticRenderFns } from "./level.vue?vue&type=template&id=0b3dde12&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3dde12",
  null
  
)

export default component.exports